import React from 'react'
import Header from "../Components/Header.js"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { CheckCircle } from 'react-feather';

export default function Policy() {

  let navigate = useNavigate()  
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const styles = {
    mail: {
      color: 'blue',
    }
  };

  const acceptAndGoBack = () => {
    localStorage.setItem('policyAccepted', 'true');
    navigate(-1); // Torna alla pagina precedente (il form)
  }  

  return (
    <>
    <Header />
    <div className="pt-3 policy-container">
        <header className="policy-header">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Ultimo aggiornamento: GDPR Febbraio 2024</p>
        </header>
        
        <div className="policy-content">
        <section className="policy-card">
            <div className="icon">🏢</div>
            <div className="details">
            <h2>Titolare del Trattamento</h2>
            <p><strong>Francesco Bonin</strong></p>
            <p>Via G.B. Scarpari 1/F - 45011 Adria RO</p>
            <p>C.F. BNNFNC70T17A059G</p>
            <p>Rappresentante legale: Francesco Bonin</p>
            <p>Telefono: +39 3289738885</p>
            <p style={styles.mail}>📧<span className="pe-1"></span><u>wild.dolomiti.app@gmail.com</u></p>
            </div>
        </section>

        <section className="policy-card">
            <div className="icon">🔍</div>
            <div className="details">
            <h2>Dati Raccolti</h2>
            <ul>
                <li>Dati di contatto (Email, Telefono)</li>
                <li>Dati anagrafici (Nome e Cognome)</li>
                <li>Dati di navigazione tramite LocalStorage</li>
            </ul>
            </div>
        </section>

        <section className="policy-card">
            <div className="icon">⚙️</div>
            <div className="details">
            <h2>Finalità e Tracciamento</h2>
            <p>I dati sono raccolti esclusivamente per <strong>rispondere alle tue richieste</strong>.</p>
            <div className="notice-box">
                <strong>Nota sui Cookies:</strong> L'App <u>non utilizza</u> cookies di profilazione. Usiamo il <em>localStorage</em> solo per ricordare la tua accettazione di questa policy.
            </div>
            </div>
        </section>

        <section className="policy-card">
            <div className="icon">🛡️</div>
            <div className="details">
            <h2>Conservazione dei Dati</h2>
            <p>L'App utilizza tecnologia <strong>Serverless</strong> pertanto non dispone di alcun database.</p>
            <p>I dati ricevuti via e-mail vengono conservati sui server sicuri di <strong>Google/Gmail</strong> per il tempo strettamente necessario all'evasione della richiesta.</p>
            </div>
        </section>
        </div>
        <div className="d-flex flex-column align-items-center pt-4 pb-5 mb-3">
            <button type="button" className="contact-button-submit" onClick={acceptAndGoBack}>
                Accetta e Torna al Form <CheckCircle size={18} />
            </button>
        </div>
    </div>
    </>
  )
}
